<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>

    
    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab @click="showNewApplications=true;showResolvedApplications=false">
          Pending Orders
          <v-chip v-if="pendingOrders" color="primary" class="white--text">{{pendingOrders.length}}</v-chip>
        </v-tab>
        <v-tab @click="showNewApplications=false;showResolvedApplications=true">
          Completed Orders
          <v-chip color="success" v-if="resolvedOrders" class="white--text">{{resolvedOrders.length}}</v-chip>
        </v-tab>
      </v-tabs>
    </v-toolbar>
    <!-- <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-text-field
      v-if="showNewApplications"
        v-model="pendingSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
      <v-text-field
      v-if="showResolvedApplications"
        v-model="resolvedSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    </v-toolbar> -->

    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <v-flex v-if="showNewApplications">
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :loading="isLoading"
      :items="pendingOrders"
      item-key="id"
      disable-initial-sort
      :pagination.sync="pagination"
      align-center
      style="cursor: pointer"
     
    >
      <template v-slot:items="props">
        <td class="text-xs-center" >{{props.item.id}}</td>
        <td
          class="text-xs-center"
        >{{formatDate(props.item.createdAt)}}</td>       

        <td v-if="props.item.location"
          class="text-xs-center"
        >{{props.item.location.locationDescription}}</td>
           <td v-else
          class="text-xs-center"
        >{{props.item.streetNumber}} {{props.item.streetName}}</td>
        <td
          class="text-xs-center"
          v-if="props.item.packagesIspId&&props.item.ispVerified&&props.item.ispAccepted"
        >
          <v-chip color="success" class="white--text">Accepted</v-chip>
        </td>
        <td
          class="text-xs-center"
          v-else-if="props.item.packagesIspId&&props.item.ispVerified&&!props.item.ispAccepted"
        >
          <v-chip color="red" class="white--text">Rejected</v-chip>
        </td>
        <td
          class="text-xs-center"
          v-else-if="props.item.packagesIspId"
        >
          <v-chip color="warning" class="white--text">Pending</v-chip>
        </td>
        <td class="text-xs-center"  v-else>
          <v-chip color="grey" class="white--text">N/A</v-chip>
        </td>
        <td
          class="text-xs-center"
          v-if="props.item.isInstallVerified"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>

        <td
          class="text-xs-center"
          v-if="props.item.isDeviceVerified"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center"  v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
        <td
          class="text-xs-center"
          v-if="props.item.isContactVerified"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
        <td
          class="text-xs-center"
          v-if="props.item.primaryContactTitle!==null"
        >{{props.item.primaryContactTitle + ' '+props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}</td>
        <td
          class="text-xs-center"
          v-else
        >{{props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}</td>

        <td
          class="text-xs-center"
        >{{props.item.primaryContactMobileNumber}}</td>
        <td
          class="text-xs-center"
        >{{props.item.primaryContactEmailAddress}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
      </v-flex>
    <v-flex v-if="showResolvedApplications">
      <v-data-table
        :headers="resolvedHeaders"
        class="elevation-1"
        :loading="isLoading"
        :items="resolvedOrders"
        :pagination.sync="pagination"
        item-key="id"
        disable-initial-sort
        align-center
        style="cursor: pointer"
      
      >
        <template v-slot:items="props">
          <td
            class="text-xs-center"
          >{{props.item.id}}</td>
         <td v-if="props.item.location"
          class="text-xs-center"
        >{{props.item.location.locationDescription}}</td>
           <td v-else
          class="text-xs-center"
        >{{props.item.streetNumber}} {{props.item.streetName}}</td>
          <td
            class="text-xs-center"
            v-if="props.item.isApproved"
          >
            <v-chip class="green white--text">Approved</v-chip>
          </td>
          <td class="text-xs-center" v-else>
            <v-chip class="red white--text">Denied</v-chip>
          </td>
          <td
            class="text-xs-center"
          >{{formatDate(props.item.createdAt)}}</td>
          <td
            class="text-xs-center"
          >{{formatDate(props.item.resolvedDate)}}</td>
          <td
            class="text-xs-center"
            v-if="props.item.resolvedById"
          >{{props.item.resolvedBy.name}} {{props.item.resolvedBy.surname}}</td>
          <td v-else></td>
          <td
            class="text-xs-center"
          >{{props.item.deniedReason}}</td>
          <td
            v-if="props.item.primaryContactId!==null"
            class="text-xs-center"
          >{{props.item.primaryContact.name}} {{props.item.primaryContact.surname}}</td>
          <td class="text-xs-center" v-else></td>
          <td
            v-if="props.item.primaryContactId!==null"
            class="text-xs-center"
          >{{props.item.primaryContact.mobileNumber}}</td>
          <td class="text-xs-center" v-else></td>
          <td
            v-if="props.item.primaryContactId!==null"
            class="text-xs-center"
          >{{props.item.primaryContact.emailAddress}}</td>
          <td class="text-xs-center" v-else></td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </v-flex>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";

export default {
  data() {
    return {
      pendingOrders:[],
      resolvedOrders:[],
      showDetails: true,
      showNewApplications: true,
      showResolvedApplications: false,
      isLoading: false,
      expand: false,
      search: "",
      dialog: false,
      snackbar: false,
      text: "",
      y: "top",
      allVlans: [],
      newApplications: [],
      newDialog: false,
      pagination: {
      },
      tabs: [
        { name: "newApplications", displayName: "Pending" },
        { name: "resolvedApplications", displayName: "Resolved" }
      ],
      resolvedHeaders: [
        {
          text: "Order ID:",
          align: "center",
          value: "id"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Status",
          align: "center",
          sortable: false
        },
        {
          text: "Submitted",
          align: "center",
          value: "createdAt"
        },
        {
          text: "Resolved Date",
          align: "center",
          value: "resolvedDate"
        },
        {
          text: "Resolved By",
          align: "center",
          value: "resolvedBy"
        },
        {
          text: "Comment",
          align: "center",
          value: "deniedReason"
        },
        {
          text: "Contact Name",
          align: "center",
          value: "primaryContactName"
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "primaryContactMobileNumber"
        },
        {
          text: "Email Address",
          align: "center",
          value: "primaryContactEmailAddress"
        }
      ],
      headers: [
        {
          text: "Application ID:",
          align: "center",
          value: "id"
        },
        {
          text: "Submitted",
          align: "center",
          value: "createdAt"
        },
        
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "ISP Acceptance",
          align: "center",
          value: "ispVerified"
        },
        {
          text: "Install Verified",
          align: "center",
          value: "isInstallVerified"
        },
        {
          text: "Device Verified",
          align: "center",
          value: "isDeviceVerified"
        },
        {
          text: "Contact Verified",
          align: "center",
          value: "isContactVerified"
        },
        {
          text: "Contact Name",
          align: "center",
          value: "primaryContactName"
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "primaryContactMobileNumber"
        },
        {
          text: "Email Address",
          align: "center",
          value: "primaryContactEmailAddress"
        }
      ],      
    };
  },

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {   
  },
  async created() {    
      this.initialize()
  },

  methods: {
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    initialize() {
        this.isLoading = true
        this.fetchPendingOrders()
        this.fetchResolvedOrders()
        this.setActiveTabName("newApplications");
    },
    fetchPendingOrders(){
        Api().post('/customer/application/pending',{
          contactId: this.$store.state.user.id,
          emailAddress: this.$store.state.user.emailAddress
        } ).then(response=>{
            this.pendingOrders = response.data
        })
    },
    fetchResolvedOrders(){
       Api().post('/customer/application/resolved' ,{
          contactId: this.$store.state.user.id,
          emailAddress: this.$store.state.user.emailAddress
       }).then(response=>{
            this.resolvedOrders = response.data
            this.isLoading = false
        }) 
    }
  }
};
</script>
